import { render, staticRenderFns } from "./CollapsibleAside.vue?vue&type=template&id=5a88b30e&scoped=true&"
import script from "./CollapsibleAside.vue?vue&type=script&lang=js&"
export * from "./CollapsibleAside.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleAside.vue?vue&type=style&index=0&id=5a88b30e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a88b30e",
  null
  
)

export default component.exports